import { schema } from "normalizr";

export const policySchema = new schema.Entity("policies");
